import { render, staticRenderFns } from "./PrintSettings.vue?vue&type=template&id=0bfa8359&"
import script from "./PrintSettings.vue?vue&type=script&lang=js&"
export * from "./PrintSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports